const translation: Record<string, string> = {
  "site.name": "本子网站",
  "site.slogan": "正版二次元漫画在线阅读平台",
  "site.description": "汇聚海量日系漫画、同人志、原创本子内容，支持高清浏览、分类检索，随时随地畅享优质本子内容。",

  "nav.home": "首页",
  "nav.category": "分类",
  "nav.about": "关于我们",
  "nav.search": "搜索漫画...",
  "nav.login": "登录",
  "nav.register": "注册",

  "home.hero.title": "探索二次元的无限可能",
  "home.hero.subtitle": "海量正版日系漫画、同人志、原创本子，高清画质，随时随地畅快阅读",
  "home.hero.cta": "立即免费阅读",
  "home.hero.browse": "浏览分类",

  "home.featured.title": "热门推荐",
  "home.featured.subtitle": "编辑精选，不容错过的优质本子",
  "home.featured.viewAll": "查看全部",

  "home.category.title": "漫画分类",
  "home.category.subtitle": "按类别探索你喜爱的漫画内容",

  "home.latest.title": "最新更新",
  "home.latest.subtitle": "持续更新，追更不等待",

  "home.faq.title": "常见问题",
  "home.faq.subtitle": "关于本子网站，你想知道的都在这里",

  "home.cta.title": "开启你的二次元阅读之旅",
  "home.cta.subtitle": "注册即可免费体验海量正版本子内容，随时随地畅享高清阅读",
  "home.cta.button": "免费注册",

  "category.title": "漫画分类",
  "category.all": "全部",
  "category.breadcrumb": "分类",
  "category.noResults": "暂无该分类的漫画",

  "article.read": "开始阅读",
  "article.chapters": "章节列表",
  "article.author": "作者",
  "article.category": "分类",
  "article.tags": "标签",
  "article.views": "阅读",
  "article.rating": "评分",
  "article.status": "状态",
  "article.status.ongoing": "连载中",
  "article.status.completed": "已完结",
  "article.updated": "最近更新",
  "article.related": "相关推荐",
  "article.backToList": "返回列表",
  "article.breadcrumb.home": "首页",
  "article.breadcrumb.article": "文章",

  "about.title": "关于我们",
  "about.breadcrumb": "关于我们",
  "about.brand.title": "品牌介绍",
  "about.brand.description": "本子网站成立于2024年，是专为二次元爱好者打造的正版漫画在线阅读平台。我们致力于为广大漫画爱好者提供高品质、正版的日系漫画、同人志和原创本子内容，打造一个纯净、便捷、高品质的阅读社区。",
  "about.brand.mission": "我们的使命",
  "about.brand.missionText": "让每一位二次元爱好者都能方便快捷地获取正版漫画内容，支持创作者，推动二次元文化健康发展。",
  "about.brand.vision": "我们的愿景",
  "about.brand.visionText": "成为华语地区最受欢迎的二次元漫画阅读平台，构建创作者与读者之间的桥梁。",

  "about.reputation.title": "用户口碑",
  "about.reputation.subtitle": "来自用户的真实评价",
  "about.reputation.count": "累计好评",

  "about.contact.title": "联系我们",
  "about.contact.subtitle": "如有任何问题或建议，欢迎随时与我们联系",
  "about.contact.email": "电子邮箱",
  "about.contact.emailValue": "contact@benziwz.com",
  "about.contact.qq": "QQ群",
  "about.contact.qqValue": "873621594",
  "about.contact.wechat": "微信公众号",
  "about.contact.wechatValue": "本子网站官方",
  "about.contact.address": "办公地址",
  "about.contact.addressValue": "东京都千代田区外神田1-1-1",

  "about.stats.users": "注册用户",
  "about.stats.manga": "漫画作品",
  "about.stats.chapters": "章节总数",
  "about.stats.daily": "日活跃",

  "footer.copyright": "本子网站 - 正版二次元漫画在线阅读平台",
  "footer.rights": "版权所有",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.dmca": "版权声明",
  "footer.contact": "联系我们",

  "search.placeholder": "搜索你喜欢的漫画...",
  "search.noResults": "未找到相关漫画",

  "ui.loading": "加载中...",
  "ui.error": "加载失败",
  "ui.retry": "重试",
  "ui.scrollTop": "回到顶部",
};

export default translation;